<template>
  <el-scrollbar>
    <div style="margin: 20px">
      <el-form label-width="140px" style="margin: 5px">
        <el-row>
          <el-col :span="12">
            <el-form-item label="职级类型：" required>
              <el-select @change="levelTypeChange()" :disabled="!isAdd" v-model="levelData.level_type" clearable placeholder="职级类型" >
                <el-option v-for="item in levelTypeList" :key="item.value" :label="item.name" :value="item.value"/>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="职级：" required>
              <el-input disabled v-model="levelData.level" placeholder="职级"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="称号：" required>
              <el-input v-model="levelData.title" clearable placeholder="称号"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="最低从业年限：" required>
              <el-input v-model="levelData.min_year" type="number"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-row :span="12">
            <el-form-item label="工资范围：" required>
              <el-input v-model="levelData.min_salary" placeholder="最低" step="1000" type="number"/>
            </el-form-item>
            <label>～</label>
            <el-form-item label-width="0" required>
              <el-input v-model="levelData.max_salary" placeholder="最高" step="1000" type="number"/>
            </el-form-item>
          </el-row>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="项目奖金：" required>
              <el-input v-model="levelData.bonus_point" :rows="3" type="textarea"/>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="额外补贴与奖励：" required>
              <el-input v-model="levelData.extra_allowance" :rows="3" type="textarea"/>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="工作内容：" required>
              <el-input v-model="levelData.work_content" :rows="3" type="textarea"/>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <h4 style="margin: 5px">晋升前置条件：</h4>
      <el-form class="bordered-container">
        <el-table :cell-style="{'text-align':'center'}"
                  :data="certificationData"
                  :header-cell-style="{'text-align':'center'}">
          <el-table-column label="" width="50">
            <template v-slot="scope">
              <el-button circle class="custom-circle-button" plain type="danger"
                         @click="removeCertificationData(scope.$index)">
                <svg fill="none" height="16" viewBox="0 0 24 24" width="20" xmlns="http://www.w3.org/2000/svg">
                  <line stroke="currentColor" stroke-width="2" x1="2" x2="22" y1="12" y2="12"></line>
                </svg>
              </el-button>
            </template>
          </el-table-column>
          <el-table-column label="序号" type="index" width="70"></el-table-column>
          <el-table-column label="认证简称">
            <template v-slot="scope">
              <el-select v-model="scope.row.id" width="100" @change="getCertificationName(scope.$index)" filterable>
                <el-option v-for="item in swCertificationList"
                           :key="item.id"
                           :label="item.short_name"
                           :value="item.id"/>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column label="认证名称">
            <template v-slot="scope">
              <el-input v-model="scope.row.name" disabled></el-input>
            </template>
          </el-table-column>
        </el-table>
        <el-button circle class="mb-4" icon="el-icon-plus" plain
                   style="float: right;margin-top: 5px" type="primary" @click="addCertificationData"></el-button>
      </el-form>
      <h4 style="margin-left: 5px">考核前置条件：</h4>
      <el-form class="bordered-container">
        <el-table :cell-style="{'text-align':'center'}"
                  :data="examData"
                  :header-cell-style="{'text-align':'center'}">
          <el-table-column label="" width="50">
            <template v-slot="scope">
              <el-button circle class="custom-circle-button" plain type="danger" @click="removeExamData(scope.$index)">
                <svg fill="none" height="16" viewBox="0 0 24 24" width="20" xmlns="http://www.w3.org/2000/svg">
                  <line stroke="currentColor" stroke-width="2" x1="2" x2="22" y1="12" y2="12"></line>
                </svg>
              </el-button>
            </template>
          </el-table-column>

          <el-table-column label="序号" type="index" width="70"></el-table-column>
          <el-table-column label="考核前置条件">
            <template v-slot="scope">
              <el-input v-model="scope.row.exam_content" width="100"></el-input>
            </template>
          </el-table-column>
        </el-table>
        <el-button circle class="mb-4" icon="el-icon-plus" plain
                   style="float: right;margin-top: 5px" type="primary" @click="addExamData"></el-button>
      </el-form>
      <h4 style="margin-left: 5px">晋升考核：</h4>
      <el-form>
        <el-row style="margin: 5px">
          <el-row :span="12">
            <el-form-item label="考核形式：" required>
            </el-form-item>
            <el-checkbox-group v-model="levelData.exam_function">
              <el-checkbox label="笔试" value="written"></el-checkbox>
              <el-checkbox label="面试" value="interview"></el-checkbox>
              <el-checkbox label="提问" value="question"></el-checkbox>
            </el-checkbox-group>
          </el-row>
          <el-col :span="24">
            <el-form-item label="考官要求：" required>
              <el-input v-model="levelData.exam_requirement" :rows="2" type="textarea"/>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <h4 style="margin-left: 5px">考核内容要求：</h4>
      <el-form class="bordered-container">
        <el-table :cell-style="{'text-align':'center'}"
                  :data="contentData"
                  :header-cell-style="{'text-align':'center'}">
          <el-table-column label="" width="50">
            <template v-slot="scope">
              <el-button circle class="custom-circle-button" plain type="danger"
                         @click="removeContentData(scope.$index)">
                <svg fill="none" height="16" viewBox="0 0 24 24" width="20" xmlns="http://www.w3.org/2000/svg">
                  <line stroke="currentColor" stroke-width="2" x1="2" x2="22" y1="12" y2="12"></line>
                </svg>
              </el-button>
            </template>
          </el-table-column>

          <el-table-column label="序号" type="index" width="70"></el-table-column>
          <el-table-column label="考核内容要求">
            <template v-slot="scope">
              <el-input v-model="scope.row.exam_content" width="100"></el-input>
            </template>
          </el-table-column>
        </el-table>
        <el-button circle class="mb-4" icon="el-icon-plus" plain
                   style="float: right;margin-top: 5px" type="primary" @click="addContentData"></el-button>
      </el-form>
      <div style="margin-top: 1%;text-align: center ">
        <el-button type="primary" @click="save">保存</el-button>
      </div>
    </div>
  </el-scrollbar>
</template>

<script>

export default {
  name: "EmployeeLevelConfigAdd",
  inject: ['$fn'],
  props: {
    componentParam: {
      type: String,
      required: true
    },
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },
  computed: {
    levelTypeList(){
      return this.$store.getters['core/getDictList']('employee_level_type');
    }
  },
  data() {
    return {
      levelData: {
        exam_function:[]
      },
      isAdd: true,
      certificationData: [],
      examData: [],
      contentData: [],
      swCertificationList: [],
      exam_ids:[],
      exam_condition_ids:[]
    }
  },
  methods: {
    levelTypeChange() {
      if (this.levelData.level_type == null || this.levelData.level_type === ''){
        return
      }
      if (this.isAdd){
        let params = {
          level_type: this.levelData.level_type
        }
        this.$http("employeeLevelService.levelTypeChange",params).then(res => {
          this.levelData.level = res
        })
      }
    },
    addCertificationData() {
      if (!this.certificationData) {
        this.certificationData = []
      }
      this.certificationData.push({
        name: '',
      });
    },
    addExamData() {
      if (!this.examData) {
        this.examData = []
      }
      this.examData.push({
        exam_content: ''
      });
    },
    addContentData() {
      if (!this.contentData) {
        this.contentData = []
      }
      this.contentData.push({
        exam_content: ''
      });
    },
    removeCertificationData(index) {
      this.certificationData.splice(index, 1);
    },
    removeExamData(index) {
      this.examData.splice(index, 1);
    },
    removeContentData(index) {
      this.contentData.splice(index, 1);
    },
    validateForm() {
      for (let key in this.levelData) {
        if (this.levelData[key] === '' || this.levelData[key] === null) {
          return false;
        }
      }
      return true;
    },
    async getSwEmpCertification() {
      await this.$http("employeeLevelService.getSWCertificationList").then(data => this.swCertificationList = data)
    },
    async saveEmpLevelSetting() {
      if (Number(this.levelData.min_year) < 0 || Number(this.levelData.min_salary) < 0 || Number(this.levelData.max_salary) < 0) {
        return this.$message.error("从业年限或工资范围不能为负数，请检查");
      }
      if (!Number.isInteger(Number(this.levelData.min_year))){
        return this.$message.error("从业年限必须为非负整数，请检查");
      }
      if (Number(this.levelData.min_salary) >= Number(this.levelData.max_salary)) {
        return this.$message.error("最低工资不能高于最高工资，请检查")
      }
      if (!this.validateForm()) {
        return this.$message.error("请填写完整信息");
      }
      let params = {
        id: this.parentData.id,
        isAdd: this.isAdd,
        levelData: this.levelData,
        certificationData: this.certificationData,
        examData: this.examData,
        contentData: this.contentData,
      }
      await this.$http("employeeLevelService.saveEmpLevelSetting", params).then(() => {
      this.$message.success("保存成功！");
      this.$fn.closeWindow();
      this.$fn.search();
      })
    },
    async getData() {
      console.log("parentData", this.parentData)
      let params = {
        id: this.parentData.id
      }
      if (params.id !== undefined) {
        let data = await this.$http("employeeLevelService.getEmpLevelSettingById", params);
        this.levelData = data
        this.contentData = data.exam
        this.examData = data.exam_condition
        this.certificationData = data.certificationData
        this.exam_ids = data.exam_ids
        this.exam_condition_ids = data.exam_condition_ids
        console.log("certificationData", this.certificationData)
        console.log("data.certificationData", data.certificationData)
      }
    },
    async save() {
      await this.saveEmpLevelSetting();
    },
    async getCertificationName(index) {
      this.certificationData[index].name = this.swCertificationList.find(item => item.id === this.certificationData[index].id).name
    },
  },

  created() {
    this.getSwEmpCertification()
    this.isAdd = this.parentData.button_id === "employee_level_config_add_btn";
    if (!this.isAdd) {
      this.getData()
    }
  }
}
</script>

<style lang="less">
.bordered-container {
  border: 0.5px solid lightgrey;
  padding: 10px 20px 45px 20px;
  width: 100%;
  margin: 10px;
}
</style>